import * as React from "react";
import { debounce } from "lodash";

const { Component } = React;

import * as UserStore from "../users/UserStore";
import * as IdentityPermissionStore from "../identityPermissions/IdentityPermissionStore";

import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";
import * as AccountStore from "../account/AccountStore";

interface OrganizationUserPermissionsState {
    searchQuery: string;
    users: Array<any>;
    policies: Array<any>;
    showModal: boolean;
    user: any;
    userPermissions: Array<any>;
    userPolicies: any;
    currentUser: any;
}

interface OrganizationUserPermissionsProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class OrganizationUserPermissions extends Component<OrganizationUserPermissionsProps, OrganizationUserPermissionsState> {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: "",
            users: [],
            policies: [],
            showModal: false,
            user: undefined,
            userPermissions: [],
            userPolicies: undefined,
            currentUser: undefined,
        };
    }
    hasPermission(permission) {
        if (this.state.currentUser && this.state.userPolicies) {
            if (this.state.currentUser.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return this.state.userPolicies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    }
    componentDidMount() {
        AccountStore.GetCurrentLoggedInUser().then((user) => {
            this.setState({ currentUser: user });
        });
        PermissionStore.GetMyPermissions().then((response) => {
            this.setState({ userPolicies: response.data });
        });

        IdentityPermissionStore.ListPolicies().then((response) => {
            this.setState({ policies: response.data });
        });

        this.debouncedSearchUsers = debounce(function (query, skip, limit) {
            return UserStore.SearchUsers(query, skip, limit).then((response) => {
                this.setState({ users: response.data });
                return response;
            });
        }, 300);

        contextSubscriptionId = GetContext((context) => {
            this.debouncedSearchUsers(this.state.searchQuery, 0, 25);
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    handleQueryChange = (e) => {
        var query = e.target.value;
        this.setState({ searchQuery: query }, () => {
            if (this.state.searchQuery.length > 0) {
                this.debouncedSearchUsers(this.state.searchQuery, 0, 25);
            }
        });
    };

    debouncedSearchUsers = (query, skip, limit) => {
        return UserStore.SearchUsers(query, skip, limit).then((response) => {
            this.setState({ users: response.data });
            return response;
        });
    };

    toggleModal = () => {
        this.setState((prevState) => ({ showModal: !prevState.showModal }));
    };

    startManageUserPermissions = (user) => () => {
        IdentityPermissionStore.GetUserPermissions(user.id).then((response) => {
            this.setState({
                user: user,
                showModal: true,
                userPermissions: this.state.policies.map((policy) => ({
                    policy,
                    userHasPolicy: response.data.filter((u) => u.permission == policy).length > 0,
                })),
            });
        });
    };

    // completeRemoveUserFromOrganization = () => {
    //     try {
    //         if (this.state.userToAdd.id && this.props.organization && this.state.membershipType) {
    //             UserStore.RemoveUserFromOrganization(this.state.userToAdd.id, this.props.organization, this.state.membershipType).then((response) => {
    //                 if (response.status == 200) {
    //                     this.debouncedSearchUsers(this.state.searchQuery, 0, 25).then(() => {
    //                         this.setState({
    //                             showRemoveModal: false,
    //                         });
    //                     });
    //                 }
    //             });
    //         }
    //     } catch (e) {}
    // };

    handlePermissionChange = (permission) => (e) => {
        let value = e.target.checked;

        let promise = null;
        if (value) {
            promise = IdentityPermissionStore.GiveUserPermission(this.state.user.id, permission);
        } else {
            promise = IdentityPermissionStore.RevokeUserPermission(this.state.user.id, permission);
        }
        promise.then((response) => {
            this.startManageUserPermissions(this.state.user)();
        });
    };

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Search</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" name="search" value={this.state.searchQuery} onChange={this.handleQueryChange} />
                    </div>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Name</th>
                            <th style={{ width: "60%" }}></th>
                        </tr>
                    </thead>
                    {this.state.users.length > 0 && (
                        <tbody>
                            {this.state.users.map((user) => (
                                <tr key={user.id}>
                                    <td>
                                        {user.fullName} <span className="text-muted">({user.userName})</span>
                                    </td>
                                    <td>
                                        {/* remove getUserPermissions policy */}
                                        {this.hasPermission("getUserPermissions") && (
                                            <button className="btn btn-primary btn-sm" onClick={this.startManageUserPermissions(user)}>
                                                {this.hasPermission("manageUserPermissions") ? "Manage Permissions" : "View Permissions"}
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>
                <Modal isOpen={this.state.showModal} toggle={this.toggleModal} centered={true}>
                    <ModalHeader toggle={this.toggleModal}>User Permissions</ModalHeader>
                    <ModalBody>
                        <table className="table-condensed">
                            <thead>
                                <tr>
                                    <th style={{ width: "70%" }}>Permission</th>
                                    <th style={{ width: "70%" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.userPermissions.map((permission) => (
                                    <tr key={permission.policy}>
                                        <td>{permission.policy}</td>
                                        <td>
                                            <Input
                                                type="switch"
                                                label=""
                                                id={permission.policy}
                                                checked={permission.userHasPolicy}
                                                onChange={this.handlePermissionChange(permission.policy)}
                                                disabled={!this.hasPermission("manageUserPermissions")}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.toggleModal}>
                            Done
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
